import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "deceased_name",
    label: "Deceased Name",
    required: true,
    showInTable: true,
  },
  { name: "relation", label: "Relation", showInTable: true },
  { name: "family_name", label: "Family Name", showInTable: true },
  {
    name: "family_mobile",
    label: "Family Mobile",
    type: "tel",
    showInTable: true,
  },
  { name: "family_email", label: "Family Email", type: "email" },
  { name: "death_date", label: "Death Date", type: "date", showInTable: true },
  { name: "tithi_date", label: "Tithi (Hindu Date)" },
  { name: "remind_days_before", label: "Remind Days Before", type: "number" },
  { name: "photo_url", label: "Photo URL", type: "url" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export default function Page() {
  return (
    <AdminShell
      title="Punya Tithi"
      subtitle="Death anniversary records & reminders"
    >
      <ResourceTable
        table="punya_tithi"
        title="Punya Tithi"
        fields={fields}
        searchFields={["deceased_name", "family_name", "family_mobile"]}
      />
    </AdminShell>
  );
}
